/* eslint-disable import/no-extraneous-dependencies */
import React, { useMemo, useState } from 'react';
import Model from '@tripian/model';
import { RSelectOption } from '../base/RSelect/RSelect';
import PreLoading from '../base/PreLoading/PreLoading';
import CompanionSelect from '../CompanionSelect/CompanionSelect';
import CompanionModal from '../CompanionModal/CompanionModal';
import CompanionModalMode from '../CompanionModal/CompanionModalMode';
import classes from './UserCompanionSelection.scss';

const initialCompanionRequestState: Model.CompanionRequest = { age: 0, name: '', answers: [], title: 'Family member' };

interface IUserCompanionSelection {
  selectedCompanionIds: number[];
  userCompanionQuestions: Array<Model.Question>;
  userCompanions?: Array<Model.Companion>;
  loadingCompanion: boolean;
  callbackUserCompanionAdd: (userCompoanion: Model.Companion) => void;
  userCompanionSelectionCallBack: (selectedCompanionId: number, isDeleteAction?: boolean) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  t: (value: Model.TranslationKey) => string;
}

const UserCompanionSelection: React.FC<IUserCompanionSelection> = ({ selectedCompanionIds, userCompanionQuestions, userCompanions, loadingCompanion, callbackUserCompanionAdd, userCompanionSelectionCallBack, onFocus, onBlur, t }) => {
  const [showModal, setShowModal] = useState(false);
  const [userCompanionState, setUserCompanionState] = useState<Model.CompanionRequest>(initialCompanionRequestState);

  const callBackRSelect = (selectedOptions: RSelectOption[]) => {
    const allSelectedIds: number[] = selectedOptions.map((x) => +x.value);
    const newIds: number | undefined = allSelectedIds.find((x) => !selectedCompanionIds.includes(x));
    const deletedIds: number | undefined = selectedCompanionIds.find((x) => !allSelectedIds.includes(x));
    if (newIds) userCompanionSelectionCallBack(newIds);
    else if (deletedIds) userCompanionSelectionCallBack(deletedIds, true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setUserCompanionState(initialCompanionRequestState);
  };

  const handleSubmitCompanion = (companion: Model.Companion) => {
    callbackUserCompanionAdd(companion);
    handleCloseModal();
  };

  const isDoneButtonDisabled = !userCompanionState.name.trim() || !userCompanionState.age || userCompanionState.age === 0;

  const companionsOptions: RSelectOption[] = useMemo(
    () =>
      userCompanions
        ? userCompanions
            // .filter((x) => !selectedCompanionIds.includes(x.id))
            .map((userCompanion) => ({
              value: userCompanion.id.toString(),
              label: userCompanion.name,
            }))
        : [],
    [userCompanions],
  );

  // eslint-disable-next-line no-nested-ternary
  const selectedOptionValues: string[] = selectedCompanionIds.map((x) => x.toString());

  // CompanionRequest'i Companion'a dönüştür
  const initialCompanionData: Model.Companion = {
    id: 0,
    memberOfTrip: false,
    name: userCompanionState.name,
    age: userCompanionState.age,
    title: userCompanionState.title,
    answers: userCompanionState.answers || [],
  };

  return (
    <>
      {/* <Modal show={showModal || companionLoadingList.includes(0)} backdropClick={() => {}} className={classes.userCompModal}>
        {companionLoadingList.includes(0) ? (
          <div className={classes.modalLoading}>
            <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
          </div>
        ) : null}
        <div className="p5">
          <div className="row pl3">
            <div className="col col12">
              <CloseIconButton2
                fill="#000"
                rounded
                clicked={() => {
                  setShowModal(false);
                  setUserCompanionState(initialCompanionRequestState);
                }}
              />
            </div>
            <div className="col col12">
              <h4>{t('trips.createNewTrip.form.travelerInfo.companion.title')}</h4>
              <div>{t('trips.createNewTrip.form.travelerInfo.companion.description')}</div>
            </div>
          </div>

          <div className="p2">
            <UserCompanionFormTemplate
              userCompanion={userCompanionState as Model.Companion}
              questions={userCompanionQuestions}
              callbackFormTemplateCompanion={(userCompanion) => {
                setUserCompanionState(userCompanion);
              }}
              t={t}
            />
          </div>
          <div className="row center m0">
            <div>
              <Button
                text={t('trips.createNewTrip.form.travelerInfo.companion.submit')}
                color={isDoneButtonDisabled ? 'disabled' : 'primary'}
                onClick={() => {
                  callbackUserCompanionAdd(userCompanionState as Model.Companion);
                  setUserCompanionState(initialCompanionRequestState);
                  setShowModal(false);
                }}
                disabled={isDoneButtonDisabled}
              />
            </div>
          </div>
        </div>
      </Modal> */}
      {loadingCompanion ? (
        <div className={classes.modalLoading}>
          <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
        </div>
      ) : null}
      <CompanionModal isOpen={showModal} onClose={handleCloseModal} onSubmit={handleSubmitCompanion} initialData={initialCompanionData} mode={CompanionModalMode.CREATE} questions={userCompanionQuestions || []} t={t} />
      <div
        className={classes.userCompanionSelection}
        onFocus={() => {
          if (onFocus) onFocus();
        }}
        onBlur={() => {
          if (onBlur) onBlur();
        }}
      >
        <div className={classes.userCompLeft}>
          <CompanionSelect options={companionsOptions} selectedOptionValues={selectedOptionValues} onSelectedOptionChange={callBackRSelect} placeHolder={t('trips.createNewTrip.form.travelerInfo.companion.placeholder')} />
        </div>
        <div className={classes.userCompRight}>
          <button type="button" className={classes.userCompanionAddButton} onClick={() => setShowModal(true)}>
            {t('trips.createNewTrip.form.travelerInfo.companion.add')}
          </button>
        </div>
      </div>
    </>
  );
};

export default UserCompanionSelection;
